import React from 'react'
import './reward-item.less'

const topImg = '/img/activity/hobiRecharge/top.png'
const bottomImg = '/img/activity/hobiRecharge/bottom.png'

export default function RewardItem({
  reward,
  onGiftClick,
  onMediaClick,
  getName,
  lang,
  language,
  onReceive,
  renderTopOneRoot,
  renderTopTwoRoot,
  renderTopThreeRoot,
}) {
  const rewardDetail = reward.rewardDetail || []

  const handleThumbClick = (e, item) => {
    e.stopPropagation()
    onMediaClick && onMediaClick(item)
  }

  const conf = reward
  const uee = !conf.canGet ? conf.canGet : !conf.alreadyGet
  const receiveText = (lang && (conf.alreadyGet ? lang.received : lang.receive)) || ''

  const amount = reward.rechargeAmount / 100

  return (
    <div className="reward-item">
      <div className="reward-item-top">
        <img className="reward-item-top-sizer" src={topImg} alt="" aria-hidden />
        <div className={`reward-item-title ${language === 'ar' ? 'reward-item-title-rtl' : ''}`}>
          <p className="reward-item-title-text">{lang ? lang.recharge_label : 'Recharge'}</p>
          <span className="reward-item-title-text" style={{ width: '0.1rem' }}></span>
          <p className="reward-item-title-text">{`$${amount}`}</p>
        </div>
      </div>
      <div className="reward-item-middle">
        <div className="reward-item-list">
          {rewardDetail.map((item, index) => (
            <div
              className="reward-item-card"
              key={index}
              onClick={() => onGiftClick && onGiftClick(item)}
            >
              <div className="reward-item-thumb" onClick={(e) => handleThumbClick(e, item)}>
                {!!item.svga && (
                  <img className="reward-item-play" src="/img/icon_play@2x.png" alt="" />
                )}
                <img className="reward-item-pic" src={item.pic} alt="" />
              </div>
              <div className="reward-item-label">{getName ? getName(item) : item.rewardName}</div>
            </div>
          ))}
        </div>
        {lang && (
          <div
            className={!uee ? 'reward-item-receive-btn-disabled' : 'reward-item-receive-btn'}
            onClick={() => onReceive && onReceive(reward)}
          >
            {receiveText}
          </div>
        )}
        <div style={{ width: '100%', height: '0.36rem' }}></div>

        {lang && reward.topUser && (renderTopOneRoot || renderTopTwoRoot || renderTopThreeRoot) && (
          <React.Fragment>
            <div className="reward-item-in-the-live">
              <div className="reward-item-left-live" />
              <div className="reward-item-text-text">{lang.top3_winners}</div>
              <div className="reward-item-right-live" />
            </div>
            <div className="reward-item-top-root">
              {renderTopTwoRoot && renderTopTwoRoot(reward.topUser)}
              {renderTopOneRoot && renderTopOneRoot(reward.topUser)}
              {renderTopThreeRoot && renderTopThreeRoot(reward.topUser)}
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="reward-item-bottom">
        <img className="reward-item-bottom-sizer" src={bottomImg} alt="" aria-hidden />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/pages/activity/hobiRecharge/reward-item.js